<p-toast></p-toast>

<app-page-shell>

    <app-page-detail-hero [auditStamp]="rule ? { createdAt: rule.createdAt, updatedAt: rule.updatedAt } : null"
        icon="pi pi-wallet"
        eyebrow="Salary Rule"
        [title]="rule?.vehicleTypeName || '-'"
        [subtitle]="(rule?.dailyRate ?? 0) + ' ' + (rule?.currencyCode || 'SAR') + ' per day'">
        <div tags>
            <p-tag [value]="rule?.active === false ? 'Inactive' : 'Active'" [severity]="activeSeverity(rule?.active)"></p-tag>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (onClick)="back()"></p-button>
            <p-button label="Edit" icon="pi pi-pencil" (onClick)="edit()"></p-button>
        </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Rule Metadata" subtitle="Read-only salary rule values.">
        <div class="info-grid">
            <div>
                <span>Truck Type</span>
                <strong>{{ rule?.vehicleTypeName || '-' }}</strong>
            </div>
            <div>
                <span>Daily Rate</span>
                <strong>{{ rule?.dailyRate ?? 0 }} {{ rule?.currencyCode || 'SAR' }}</strong>
            </div>
            <div>
                <span>Effective From</span>
                <strong>{{ dateLabel(rule?.effectiveFrom) }}</strong>
            </div>
            <div>
                <span>Effective To</span>
                <strong>{{ dateLabel(rule?.effectiveTo) }}</strong>
            </div>
            <div>
                <span>Priority</span>
                <strong>{{ rule?.priority ?? 0 }}</strong>
            </div>
        </div>
    </app-page-data-panel>

    <app-page-data-panel title="Notes" subtitle="Rule notes and business context.">
        <p>{{ rule?.notes || 'No notes.' }}</p>
    </app-page-data-panel>
</app-page-shell>
